import apiFetch from "app/util/apiFetch";

export default function loadPatientsForNoneRisk(
  locationIds,
  startTime,
  endTime,
  nextCursor
) {
  return dispatch => {
    let payload, type;

    if (nextCursor) {
      payload = {
        location_ids: locationIds.join(),
        start_time: startTime,
        end_time: endTime,
        min_score: null,
        max_score: null,
        next_cursor: nextCursor
      };
      type = "LOCATION_NONERISK_PATIENT_LOAD_MORE";
    } else {
      payload = {
        location_ids: locationIds.join(),
        start_time: startTime,
        end_time: endTime,
        min_score: null,
        max_score: null
      };
      type = "LOCATION_NONERISK_PATIENT_LOAD";
    }

    return dispatch(
      apiFetch(`/api/v2/risk_dashboard/braden`, {
        method: "POST",
        body: payload,
        headers: {
          Accept: "application/json",
          "X-HTTP-Method-Override": "GET"
        }
      })
    ).then(({ patients, meta }) => {
      dispatch({
        type,
        patients,
        meta
      });

      return patients;
    });
  };
}
